@import '../../../theme/colors';

.addAttribute {
  display: flex;
  padding: 8px;
  padding-left: 5px;
  align-items: center;
  .label {
    font-size: 12px;
    font-family: var(--font-family__body);
    color: $neutral-600;
    margin: 0;
    &.disabled {
      color: $lightGrey;
    }
  }
}
